/* eslint-env jquery, browser, es6 */
import $ from 'jquery';

const emailRe = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const endpoint = 'https://us-central1-yes-theory-1.cloudfunctions.net';

let urlParams;
(window.onpopstate = () => {
  let match;
  const pl = /\+/g; // Regex for replacing addition symbol with a space
  const search = /([^&=]+)=?([^&]*)/g;
  const decode = s => decodeURIComponent(s.replace(pl, ' '));
  const query = window.location.search.substring(1);

  urlParams = {};
  match = search.exec(query);
  while (match) {
    urlParams[decode(match[1])] = decode(match[2]);
    match = search.exec(query);
  }
})();

function activateSpinner() {
  $('.spinner-container').removeClass('hidden');
}

function deactivateSpinner() {
  $('.spinner-container').addClass('hidden');
}

function isiOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

exports.activateSpinner = activateSpinner;
exports.deactivateSpinner = deactivateSpinner;
exports.endpoint = endpoint;
exports.isiOS = isiOS;
exports.urlParams = urlParams;
exports.validateEmail = email => emailRe.test(String(email).toLowerCase());
